import { Component, OnInit } from "@angular/core";
import { LoaderService } from "src/app/shared/services/loader-service";
import { CartService } from "src/app/shared/services/cart-service";
import { cartRotate } from "src/app/shared/animations/cartRotate";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import * as _ from "lodash";
@Component({
  selector: "app-header",
  animations: [cartRotate],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(private loader: LoaderService, public cartService: CartService,private spinnerService:SpinnerService) { }
  showMenu = false;
  shake="shakestart";
  customer;
  cart;
  countItems: number = 0;
  
  ngOnInit() {
    this.spinnerService.show();
    this.loader
      .getCustomerDetails()
      .pipe()
      .subscribe((customer) => {
        this.customer = customer;
        if (!_.isNil(this.customer)  && _.isNil(this.customer.logo)){
            this.isLoaded();
        }
      });
    this.cartService.getCartStatus().subscribe((cartOpen: boolean) => {
      this.cart = cartOpen;
    });

    this.cartService.getNumberItemsInCart().subscribe((count: number) => {
      this.countItems = count > 0 ? count : 0;
      if (this.countItems > 0) {
        this.shakeMe();
      }
      // this.shakeMe();
    });
  }

  isLoaded(){
    this.spinnerService.hide();
  }

  triggerMenu() {
    this.showMenu = !this.showMenu;
  }
  openCart() {
    this.cartService.setCart();
  }
  shakeMe() {
    this.shake = "shakeend";
    setTimeout((timeout) => {
      this.shake = "shakestart";
    }, 1000);
  }
}
